<template>
    <interaction-divider
        v-if="props.chat.closed"
    >
        <text-decorator size="xs">
            Het gesprek is beëindigd om {{ formatTime(props.chat.closedAt!) }}
        </text-decorator>
    </interaction-divider>
</template>

<script setup lang="ts">
    import type { Assistent, Interaction, Chat } from '@keyvue/one-api-client';
    import { formatTime } from '@/shared/utils/date';
    import InteractionDivider from '@/ai/assistent/components/interaction/InteractionDivider.vue';

    const props = defineProps<{
        interaction: Interaction,
        assistent: Assistent,
        chat: Chat,
    }>();
</script>

<style scoped lang="scss">
    .chat-closed-interaction-item {
        display: grid;
        grid-template-columns: 1fr max-content 1fr;
        align-items: center;
        gap: size(md);
    }
</style>
